<template>
  <div class="h-100 chat-center-container">
    <v-layout row wrap h-100>
      <v-flex xs12 class="position-relative">
        <div class="navbar elevation-3 white w-100" :class="{ blured: disconected && user.role === 'agent' }">
          <div class="navbar-header">
            <v-container class="border-bottom" py-2 grid-list-lg>
              <v-layout row wrap align-center>
                <v-flex xs10>
                  <v-layout row wrap>
                    <v-flex xs2 v-for="(channel, index) in channelList" :key="`channel-btn-${index}`">
                      <filter-btn :element="channel" :show-qty="menuDrawer">
                      </filter-btn>
                    </v-flex>
                    <v-flex xs2>
                      <filter-btn :element="allChannels" :show-qty="menuDrawer" @click.native="activeAllChannels">
                      </filter-btn>
                    </v-flex>
                    <v-flex xs2 v-if="!canSeeChatCenterWhatsapp" />
                    <v-flex xs2 class="text-xs-right mt-1">
                      <v-tooltip bottom class="mr-3">
                        <v-icon class="clickable" slot="activator" @click="showSearchCustomer = true">
                          fas fa-plus-circle
                        </v-icon>
                        <span>Iniciar chat</span>
                      </v-tooltip>
                      <v-tooltip bottom class="pr-3">
                        <v-icon class="clickable" slot="activator" @click="showQueued = true">
                          fas fa-list
                        </v-icon>
                        <span>Chats en espera</span>
                      </v-tooltip>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs2 class="text-xs-center semi-border--left">
                  <v-btn flat icon small @click="showSearch = true">
                    <v-icon small :class="{ 'k-orange-linear-text': search !== '' }">fa-search</v-icon>
                  </v-btn>
                  <v-btn flat icon small @click="modal = true">
                    <v-icon small :class="{ 'k-orange-linear-text': Object.keys(customFilters).length }">fa-filter</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </div>
          <div class="navbar-footer">
            <v-container py-0 fill-height grid-list-lg>
              <v-layout row wrap justify-center align-center>
                <status-btn
                  :key="`channel-btn-${index}`"
                  :element="s"
                  :active="activeStatus"
                  v-for="(s, index) in statusList"
                  class="text-xs-center h-100 py-0"
                  @changed="changeActiveStatu">
                </status-btn>
                <status-btn
                  :element="myChats"
                  :active="activeTab"
                  class="text-xs-center semi-border--left h-100 py-0"
                  @changed="changeView">
                </status-btn>
                <status-btn
                  v-if="user.role !== 'agent'"
                  :element="allChats"
                  :active="activeTab"
                  class="text-xs-center h-100 py-0"
                  @changed="changeView">
                </status-btn>
              </v-layout>
            </v-container>
          </div>
        </div>
        <chat-list
          :user="user"
          :chats="sortedChats"
          :is-connected="!disconected"
          :is-searching="isSearching"
          :channel-list="channelList"
          :stop-scrolling="stopScrolling"
          @open-chat="openChat"
          @search-chats="fetchChats(true)">
        </chat-list>
        <transition name="fade">
          <connect-panel v-if="disconected && user.role === 'agent'">
          </connect-panel>
        </transition>
      </v-flex>
    </v-layout>
    <chat-room
      :creating="creating"
      :key="`chat-${activeChatId}`"
      :chat="activeChat"
      :show="chatRoomOpened"
      :has-customer="hasCustomer"
      :user="user"
      :answer-template="templateSelected"
      :from-chat-center="true"
      @reasign="reasign"
      @edit="showEdit = true"
      @close="closeChatRoom"
      @reload-message="openChat"
      @setFetchMessages="activeChat.fetchMessages = true"
      @updateSendedMessage="updateSendedMessage"
      @appendMessagesToChat="transformMessageToAppend"
      @updateActiveChat="transformChatToAppend"
      @show-alert="showAlert = true"
      @openAnswerTemplates="openAnswerTemplate"
      @open-send-conversation="openSendModal"
      @assign-chat-company="fetchChatsData">
    </chat-room>
    <modal-filters
      type="chatCenter"
      :show="modal"
      :custom-filters="aditionalFilters"
      :custom-filters-values="customFilterValues"
      :old-filters="Object.keys(customFilters).length > 0 ? [customFilters] : []"
      @close="modal = false"
      @filter="applyFilters">
    </modal-filters>
    <confirm-dialog @statusChanged="unsolve"></confirm-dialog>
    <reasign-operator-dialog
      :chat="activeChat"
      :show="showReasignChatDialog"
      @close="closeReasign">
    </reasign-operator-dialog>
    <edit-customer-modal
      v-if="hasCustomer && showEdit"
      :customer="activeChat.customer"
      :show="showEdit"
      @contact-added="contactAdded"
      @contact-updated="contactUpdated"
      @customer-updated="updateCustomer"
      @close="showEdit = false">
    </edit-customer-modal>
    <search-modal :searched="search" :show="showSearch" @search="applySearch" @close="closeSearch">
    </search-modal>
    <pick-contact-method
      @selected="setNewChat"
      :customerId="newCustomerId"
      :show="showPickMethod"
      v-if="showPickMethod"
      @changeValue="showPickMethod = $event">
    </pick-contact-method>
    <search-customer
      @selected="setNewChat"
      :show="showSearchCustomer"
      :searchOnCreate="true"
      :fromChatCenter="true"
      @change-value="showSearchCustomer = $event">
    </search-customer>
    <waiting-channel :show="showQueued" @change-value="showQueued = $event">
    </waiting-channel>
    <answer-templates
      :show="showAnswerTemplate"
      :channel="activeChat.channel_id"
      @selected="selectAnswerTemplate"
      @close="closeAnswerTemplates">
    </answer-templates>
    <alert-modal
      :show="showAlert"
      @close="showAlert = false">
    </alert-modal>
    <send-conversation-modal
      :show="showSendConversation"
      :selected="selectedConversation"
      @saved="closeSendModal"
      @close="closeSendModal">
    </send-conversation-modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import _ from 'lodash';
import Vue from 'vue';
import permissionsMixin from '@/mixins/permissions';
import PickContactMethod from '@/components/customer/PickContactMethod';
import EditCustomerModal from '@/components/customer/EditCustomerModal';
import AnswerTemplates from '@/components/chat_center_v2/AnswerTemplates';
import ConfirmDialog from '@/components/chat_center/ConfirmDialog';
import SearchCustomer from '@/components/customer/SearchCustomer';
import ReasignOperatorDialog from './ReasignOperatorDialog';
import WaitingChannel from './WaitingChannel';
import ConnectPanel from './ConnectPanel';
import ModalFilters from './ModalFilters';
import SearchModal from './SearchModal';
import FilterBtn from './FilterBtn';
import StatusBtn from './StatusBtn';
import ChatList from './ChatList';
import ChatRoom from './ChatRoom';
import AlertModal from './AlertModal';
import SendConversationModal from './SendConversationModal';

const qs = require('qs');
const newChat = {
  id: 0,
  company_id: '',
  chat_center_messages: [],
  channel_id: 0,
  internal_id: 0,
  fetch_messages: false,
  customer: {},
};

const statusList = [
  {
    text: 'En espera',
    icon: 'fas fa-users',
    value: [1, 2, 3],
    qty: 0,
  },
  {
    text: 'Por responder',
    icon: {
      first: 'comment',
      second: 'ellipsis-h',
    },
    value: [4],
    qty: 0,
  },
  {
    text: 'Por resolver',
    icon: 'fas fa-clock',
    value: [5, 6],
    qty: 0,
  },
  {
    text: 'Resueltos',
    icon: {
      first: 'comment',
      second: 'check',
    },
    value: [7],
    qty: 0,
  },
];
const channelList = [
  {
    text: 'SMS',
    icon: 'fas fa-comment',
    value: 2,
    active: true,
    color: '#ff6962',
    qty: 0,
  },
  {
    text: 'Whatsapp',
    icon: 'fab fa-whatsapp',
    value: 7,
    active: true,
    color: '#00d45d',
    qty: 0,
  },
  {
    text: 'E-mail',
    icon: 'fas fa-envelope',
    value: 1,
    active: true,
    color: '#ff6962',
    qty: 0,
  },
  /* {
    text: 'Facebook',
    icon: 'fab fa-facebook-square',
    value: 15,
    active: false,
    color: '#3671ab',
    qty: 0,
  }, */
  {
    text: 'Chatbot',
    icon: 'fas fa-robot',
    value: 12,
    active: false,
    color: '#ff6962',
    qty: 0,
  },
];

export default {
  beforeRouteEnter(to, from, next) {
    const user = Vue.prototype.$auth.user();
    let { channels } = user.chat_center_filters || {};
    const { attachment } = user.chat_center_filters || {};
    if (channels) {
      channels = channels.map(item => parseInt(item, 10));
      channelList.map((channel) => {
        // eslint-disable-next-line
        channel.active = channels.includes(channel.value);
        return channel;
      });
    }
    let customFilters = {};
    if (attachment) {
      customFilters = {
        hasAttachment: attachment,
        key: 'hasAttachment',
      };
    }

    next((vm) => {
      vm.channelList = channelList.filter((channel) => {
        if (channel.value === 7) {
          return permissionsMixin.methods.checkPermissions(['see_chat_center_whatsapp'], user);
        }
        return true;
      });
      vm.customFilters = { // eslint-disable-line
        ...vm.customFilters,
        ...customFilters,
      };
    });
  },
  mounted() {
    // this.fetchConfig();
    this.fetchChatsData();
  },
  mixins: [permissionsMixin],
  components: {
    ReasignOperatorDialog,
    SendConversationModal,
    PickContactMethod,
    EditCustomerModal,
    AnswerTemplates,
    WaitingChannel,
    SearchCustomer,
    ConfirmDialog,
    ConnectPanel,
    ModalFilters,
    SearchModal,
    AlertModal,
    FilterBtn,
    StatusBtn,
    ChatList,
    ChatRoom,
  },
  data() {
    return {
      showQueued: false,
      search: '',
      showPickMethod: false,
      showSearchCustomer: false,
      limit: 12,
      modal: false,
      offset: 0,
      showEdit: false,
      showSearch: false,
      selectedChat: -1,
      isSearching: false,
      listenEvents: false,
      cancelTokenMessages: this.axios.CancelToken.source(),
      cancelToken: this.axios.CancelToken.source(),
      totalCancelToken: this.axios.CancelToken.source(),
      checkActivity: () => {},
      activeTab: ['mine'],
      activeStatus: [4],
      activeChatId: -1,
      stopScrolling: false,
      isSearchingTotals: false,
      showChatConfigModal: false,
      customFilters: {
      },
      aditionalFilters: [
        {
          text: 'Archivos adjuntos',
          value: 'hasAttachment',
        },
      ],
      customFilterValues: {
        hasAttachment: [
          {
            name: 'Con adjuntos',
            type: 'hasAttachment',
          },
          {
            name: 'Sin adjunto',
            type: 'noAttachment',
          },
        ],
      },
      showReasignChatDialog: false,
      // eslint-disable-next-line
      statusList,
      myChats: {
        text: 'Mios',
        value: ['mine'],
        qty: 0,
      },
      allChats: {
        text: 'Todos',
        value: ['all'],
        qty: 0,
      },
      channelList: [],
      allChannels: {
        text: 'Todos',
        icon: 'fas fa-asterisk',
        value: 'all',
        active: false,
        qty: 0,
      },
      chats: [],
      newChat,
      firstScroll: false,
      showAlert: false,
      selectedConversation: 0,
      showSendConversation: false,
      chatConfig: {
        config: {
          max_sms_char: 160,
        },
      },
      showAnswerTemplate: false,
      templateSelected: {},
    };
  },
  computed: {
    ...mapGetters([
      'intentionFilters',
      'menuDrawer',
      'chat_center_config',
    ]),
    creating() {
      return this.activeChatId === 0;
    },
    newCustomerId() {
      let customer = 0;
      if (this.newChat.customer) {
        customer = this.newChat.customer.id;
      }
      return customer;
    },
    userFilters() {
      return this.user.chat_center_filters;
    },
    user() {
      return this.$auth.user();
    },
    url() {
      if (this.$route.query.chat_id) {
        return `chats_center/${this.$route.query.chat_id}`;
      }
      let url = `chats_center?${qs.stringify(this.filters)}&`;
      url += `limit=${this.limit}&`;
      url += `offset=${this.offset}`;
      return url;
    },
    channel() {
      return `company.${this.user.company.id}.chatCenter`;
    },
    activeChannels() {
      return this.channelList.map(item => item.active).every(item => item);
    },
    disconected() {
      return this.user.chat_center_online === 0 || this.user.chat_center_online === false;
    },
    status() {
      const status = [];
      if (this.channels.includes(14)) {
        status.push(
          ...this.activeStatus,
          ...[
            8,
            9,
            10,
            11,
            12,
          ]);
      }
      return status;
    },
    channels() {
      return this.channelList.filter(item => item.active).map(item => item.value);
    },
    filters() {
      const filters = {
        // eslint-disable-next-line
        status: this.activeStatus.length > 0 ? this.activeStatus : [],
        channels: this.channels.length > 0 ? this.channels : [],
      };
      if (this.activeTab.includes('mine')) {
        filters.my_chats = true;
      } else {
        delete filters.myChats;
      }
      if (this.search !== '') {
        filters.search = this.search;
      }
      if (this.customFilters.minDate) {
        filters.minDate = this.customFilters.minDate;
      }
      if (this.customFilters.maxDate) {
        filters.maxDate = this.customFilters.maxDate;
      }
      if (this.customFilters.solvedBy) {
        filters.solvedBy = this.customFilters.solvedBy;
      }
      if (this.intentionFilters) {
        filters.intentions = this.intentionFilters;
      }
      if (this.customFilters.hasAttachment) {
        filters.hasAttachment = this.customFilters.hasAttachment;
      }
      return filters;
    },
    chatRoomOpened() {
      // eslint-disable-next-line
      return this.activeChatId !== -1;
    },
    sortedChats() {
      return this.chats
        .filter(item => this.passFilters(item) || this.activeChatId === item.id || item.id === 0)
        .sort((a, b) => (a.last_activity > b.last_activity ? -1 : 1));
    },
    activeChat() {
      const index = this.sortedChats.findIndex(item => item.id === this.activeChatId);
      return index === -1 ? {} : this.sortedChats[index];
    },
    hasCustomer() {
      return Object.prototype.hasOwnProperty.call(this.activeChat, 'customer');
    },
    totalUrl() {
      return `chats_center/totals_v2?${qs.stringify(this.filters)}`;
    },
    canSeeMasked() {
      return this.checkPermissions([
        'see_masked_contact_methods',
      ]);
    },
    canSeeChatCenterWhatsapp() {
      return this.checkPermissions([
        'see_chat_center_whatsapp',
      ]);
    },
  },
  methods: {
    setNewChat(chat) {
      this.newChat = {
        ...this.newChat,
        ...chat,
        company_id: this.user.company.id,
      };
      this.showSearchCustomer = false;
      this.showPickMethod = !this.showPickMethod;
      if (this.newChat.internal_id) {
        this.$set(this.chats, this.chats.length, this.newChat);
        this.openChat(0, this.newChat);
        this.newChat = newChat;
      }
    },
    activeAllChannels() {
      this.channelList.map((item) => {
        // eslint-disable-next-line
        item.active = this.allChannels.active;
        return item;
      });
    },
    changeView($event) {
      this.activeTab = $event;
    },
    changeActiveStatu($event) {
      this.activeStatus = $event;
    },
    cancelfetchChats() {
      this.cancelTokenMessages.cancel('');
      this.cancelTokenMessages = this.axios.CancelToken.source();
    },
    openChat(id, params = {}) {
      this.activeChatId = id;
      if (!this.activeChat.fetch_messages) {
        this.axios.get(`chats_center/${this.activeChat.id}/messages`, {
          cancelToken: this.cancelTokenMessages.token,
          params,
        }).then(({ data }) => {
          const index = this.sortedChats.findIndex(item => item.id === id);
          this.sortedChats[index].chat_center_messages = data;
          this.sortedChats[index].fetch_messages = true;
        }).catch(() => {});
      }
    },
    passFilters(chatCenter) {
      let flag = true;
      // agente esta conectado.
      if (this.disconected && this.user.role === 'agent') {
        flag = false;
      }
      // la pestaña mios esta activa
      const isMine = this.filters.my_chats;
      if (isMine && chatCenter.user_id !== this.user.id) {
        flag = false;
      }

      const filters = this.filters;
      // El chat pertenece al status activo
      if (filters.status.length && !filters.status.includes(chatCenter.chat_center_status_id)) {
        flag = false;
      }
      // El chat pertenece a alguno de los canales activos
      if (filters.channels.length && !filters.channels.includes(chatCenter.channel_id)) {
        flag = false;
      }
      // filtro por el modal de busqueda, nombre, rut, cuenta, medio de contacto.
      if (this.search !== '') {
        let aux = false;
        // eslint-disable-next-line
        const { user_name, internal_id, customer } = chatCenter;

        let search = this.search;
        if (!this.canSeeMasked) {
          search = this.search.slice(-3);
        }
        // eslint-disable-next-line
        if (user_name && user_name.toLowerCase().includes(search.toLowerCase())) {
          aux = true;
        }
        // eslint-disable-next-line
        if (internal_id && internal_id.toLowerCase().includes(search.toLowerCase())) {
          aux = true;
        }
        if (customer) {
          // eslint-disable-next-line
          const { name, first_name, last_name, account, fiscal_id } = customer;
          if (name && name.toLowerCase().includes(search.toLowerCase())) {
            aux = true;
          }
          // eslint-disable-next-line
          if (first_name && first_name.toLowerCase().includes(search.toLowerCase())) {
            aux = true;
          }
          // eslint-disable-next-line
          if (last_name && last_name.toLowerCase().includes(search.toLowerCase())) {
            aux = true;
          }
          // eslint-disable-next-line
          if (account && account.toLowerCase().includes(search.toLowerCase())) {
            aux = true;
          }
          // eslint-disable-next-line
          if (fiscal_id && fiscal_id.toLowerCase().includes(search.toLowerCase())) {
            aux = true;
          }
        }
        if (!aux) {
          flag = false;
        }
      }
      // filtro de fecha minimo
      if (Object.prototype.hasOwnProperty.call(this.customFilters, 'minDate')) {
        if (!moment(chatCenter.last_activity).isAfter(`${this.customFilters.minDate} 00:00:01`, 'minute')) {
          flag = false;
        }
      }
      // filtro de fecha maxima
      if (Object.prototype.hasOwnProperty.call(this.customFilters, 'maxDate')) {
        if (!moment(chatCenter.last_activity).isBefore(`${this.customFilters.maxDate} 23:59:59`, 'minute')) {
          flag = false;
        }
      }
      // filtro de solucionado por
      if (Object.prototype.hasOwnProperty.call(this.customFilters, 'solvedBy')) {
        const messages = chatCenter.chat_center_messages;
        const movements = messages.filter(item => item.type !== 'message' && item.origin === 1);
        if (movements.length) {
          const lastMovement = movements[movements.length - 1];
          if (!Object.keys(lastMovement.chat_category).length) {
            flag = false;
          } else if (lastMovement.chat_category.type !== this.customFilters.solvedBy) {
            flag = false;
          }
        } else {
          flag = false;
        }
      }
      // eslint-disable-next-line
      if (this.intentionFilters.length && !this.intentionFilters.includes(chatCenter.intention_id)) {
        flag = false;
      }
      if (this.customFilters.hasAttachment) {
        if (this.customFilters.hasAttachment === 'hasAttachment') {
          if (chatCenter.has_attachtment === 0) {
            flag = false;
          }
        } else {
          if (chatCenter.has_attachtment === 1) {
            flag = false;
          }
        }
      }
      return flag;
    },
    closeChatRoom(id) {
      this.$router.replace({query: {}});
      this.cancelfetchChats();
      setTimeout(() => {
        this.activeChatId = -1;
        const index = this.chats.findIndex(item => item.id === id);
        if (index !== -1 && !this.passFilters(this.chats[index])) {
          this.chats.splice(index, 1);
        }
      }, 250);
    },
    clearChatCenter() {
      this.chats = [];
      this.offset = 0;
      this.activeChatId = -1;
    },
    cancelRequest() {
      this.firstScroll = false;
      this.cancelToken.cancel('Canceled by user');
      this.cancelToken = this.axios.CancelToken.source();
    },
    unionWith(val, otherVal) {
      if (
        val.internal_id === otherVal.internal_id &&
        val.channel_id === otherVal.channel_id &&
        val.subject === otherVal.subject
      ) {
        return true;
      }
      return false;
    },
    fetchChats(scroll = false) {
      if (!scroll && !this.firstScroll) {
        this.clearChatCenter();
        this.stopScrolling = false;
      }
      if (!this.stopScrolling) {
        this.cancelRequest();
        const obj = {
          params: {
            global_inbox: this.$route.name === 'ChatCenterV2Inbox',
          },
        };
        obj.cancelToken = this.cancelToken.token;
        // if (this.isSearching) {
        //   obj.cancelToken = this.cancelToken.token;
        // }
        this.isSearching = true;
        this.axios.get(this.url, obj).then(({ data }) => {
          if (this.$route.query.chat_id) {
            this.chats.push(data);
            this.openChat(data.id, data);
          } else {
            this.chats = _.unionWith(data, this.chats, this.unionWith);
            if (!data.length || (this.chats.length && (data.length + this.chats.length) <= this.limit)) { // eslint-disable-line
              this.stopScrolling = true;
            } else {
              this.stopScrolling = false;
            }
          }
          if (!this.listenEvents) {
            this.listenEvents = true;
          }
          this.isSearching = false;
          setTimeout(() => {
            this.firstScroll = true;
          }, 200);
        }).catch((error) => {
          if (
            error.message !== "Canceled by user" &&
            error.response.status !== 403
          ) {
            this.isLoading = false;
            this.$vs.notify({
              title: 'Error',
              text: 'Error inesperado, intente de nuevo mas tarde',
              color: 'danger',
              icon: 'error',
              position: 'bottom-right',
            });
          }
        });
      }
    },
    applyFilters($event) {
      //
      this.modal = false;
      this.customFilters = {
        ...$event,
      };
    },
    startListeningEvents() {
      window.Echo.private(this.channel)
        .listen('.ChatCenterUpdated', (event) => {
          let chatCenter = {};
          if (event.chatCenter) {
            chatCenter = event.chatCenter;
          } else {
            chatCenter = event;
          }
          const index = this.chats.findIndex(item => item.id === chatCenter.id);

          this.changeTabsTotals(chatCenter);
          if (index >= 0) {
            this.updateChatInList(index, chatCenter);
          } else {
            this.appendChatToList(chatCenter);
          }
        })
        .listen('.ChatCenterMessageUpdated', ({ ChatCenterMessage }) => {
          // eslint-disable-next-line
          if (Object.keys(this.activeChat || {}).length) {
            const message = this.activeChat.chat_center_messages.findIndex(x => x.id === ChatCenterMessage.id);
            if (message >= 0) {
              this.$set(this.activeChat.chat_center_messages, message, {
                ...this.activeChat.chat_center_messages[message],
                ...ChatCenterMessage,
              });
            }
          }
        })
        .listen('.ChatCenterMessageCreated', (event) => {
          // eslint-disable-next-line
          const chatCenter = {
            ...event.chatCenter,
          };
          const chatCenterMessage = {
            ...event.chatCenterMessage,
          };
          chatCenter.chat_center_messages = [
            chatCenterMessage,
          ];
          const index = this.chats.findIndex(item => item.id === chatCenter.id);
          if (index >= 0) {
            this.updateChatInList(index, chatCenter);
          } else {
            this.appendChatToList(chatCenter);
          }
        });
      this.checkActivity = setInterval(() => {
        if (this.activeChatId > 0) {
          this.axios.get('chats_center/presence');
        }
      }, 600000);
    },
    stopListeningEvents() {
      window.Echo.leave(this.channel);
      clearInterval(this.checkActivity);
    },
    transformMessageToAppend(message) {
      const index = this.chats.findIndex(item => item.id === this.activeChat.id);
      if (index !== -1) {
        this.appendMessagesToChat(index, this.activeChat.id, {
          ...message,
        });
      }
    },
    appendMessagesToChat(index, chatId, messages) {
      const newItem = this.chats[index];
      const newMessages = _.orderBy(newItem.chat_center_messages.concat(messages), 'created_at', 'asc');
      newItem.chat_center_messages = newMessages;
      this.$set(this.chats, index, newItem);
    },
    updateSendedMessage($event) {
      if (Array.isArray($event.chatCenterMessage)) {
        return;
      }
      const index = this.chats.findIndex(item => item.id === $event.id);
      if (index === -1) {
        return;
      }
      const idx = this.chats[index].chat_center_messages
        .findIndex(item => item.identifier && item.identifier === $event.identifier);
      if (idx !== -1 && $event.chatCenterMessage && Object.keys($event.chatCenterMessage).length > 0) {
        this.$set(this.chats[index].chat_center_messages, idx, $event.chatCenterMessage);
      }
    },
    transformChatToAppend(chatCenter) {
      const index = this.chats.findIndex(item => item.id === chatCenter.id);
      if (index !== -1) {
        this.updateChatInList(index, chatCenter);
      }
    },
    appendChatToList(chatCenter) {
      if (this.passFilters(chatCenter)) {
        this.chats.unshift(chatCenter);
      }
    },
    updateChatInList(index, chatCenter) {
      if (this.activeChatId !== -1 && this.activeChatId !== chatCenter.id && !this.passFilters(chatCenter)) {
        this.chats.splice(index, 1);
      } else {
        const messages = this.chats[index].chat_center_messages || [];
        const incomingMessages = Array.isArray(chatCenter.chat_center_messages)
          ? chatCenter.chat_center_messages
          : [];
        const newMessages = incomingMessages.length
          ? _.uniqBy(messages.concat(incomingMessages), 'id')
          : messages;
        const newItem = {
          ...this.chats[index],
          ...chatCenter,
        };
        newItem.chat_center_messages = incomingMessages.length
          ? _.orderBy(newMessages, 'created_at', 'asc')
          : messages;
        const passFilters = this.passFilters(newItem);
        if (!passFilters) {
          newItem.disabled = true;
        } else if (passFilters && this.chats[index].disabled) {
          newItem.disabled = false;
        }
        this.$set(this.chats, index, newItem);
      }
    },
    markSolved(id) {
      const index = this.chats.findIndex(item => item.id === id);
      if (index !== -1) {
        const chatCenter = this.chats[index];
        chatCenter.chat_center_status_id = 7;
        if (!this.filters.status.includes(7)) {
          chatCenter.disabled = true;
        }
        this.updateChatInList(index, chatCenter);
      }
    },
    unsolve($event) {
      const index = this.chats.findIndex(item => item.id === $event.id);
      if (index !== -1) {
        this.chats[index].chat_center_status_id = $event.status;
        if (this.activeSubTab === '2') {
          this.$set(this.chats[index], 'disabled', true);
        }
      }
    },
    reasign() {
      this.showReasignChatDialog = true;
    },
    closeReasign() {
      this.selectedChat = -1;
      this.showReasignChatDialog = false;
    },
    contactAdded() {
      //
    },
    contactUpdated() {
      //
    },
    updateCustomer(customer) {
      this.activeChat.customer = customer;
    },
    fetchTotals() {
      this.totalCancelToken.cancel('Canceled by user');
      this.totalCancelToken = this.axios.CancelToken.source();
      this.axios.get(this.totalUrl, {
        cancelToken: this.totalCancelToken.token,
        params: {
          global_inbox: this.$route.name === 'ChatCenterV2Inbox',
        },
      }).then(({ data }) => {
        // const { chats } = data;
        const { chats, intents } = data;
        this.statusList.map((item) => {
          // eslint-disable-next-line
          item.qty = 0;
          return item;
        });
        this.channelList.map((item) => {
          // eslint-disable-next-line
          item.qty = 0;
          return item;
        });
        this.myChats.qty = 0;
        this.allChats.qty = 0;
        for (let i = 0; i < chats.length; i += 1) {
          // eslint-disable-next-line
          const status = this.statusList.find(x => x.value.includes(chats[i].chat_center_status_id));
          const channel = this.channelList.find(x => x.value === chats[i].channel_id);
          // eslint-disable-next-line
          if ((this.filters.my_chats && chats[i].user_id === this.user.id) || !this.filters.my_chats) {
            if (chats[i].chat_center_status_id !== 7) {
              channel.qty += parseInt(chats[i].qty, 10);
            }
            status.qty += parseInt(chats[i].qty, 10);
          }
          if (chats[i].chat_center_status_id !== 7) {
            if (chats[i].user_id === this.user.id) {
              this.myChats.qty += parseInt(chats[i].qty, 10);
            }
            this.allChats.qty += parseInt(chats[i].qty, 10);
          }
        }
        this.$store.commit('UPDATE_INTENTIONS', intents);
      }).catch((error) => {
        if (
            error.message !== "Canceled by user" &&
            error.response.status !== 403
          ) {
            this.isLoading = false;
            this.$vs.notify({
              title: 'Error',
              text: 'Error inesperado, intente de nuevo mas tarde',
              color: 'danger',
              icon: 'error',
              position: 'bottom-right',
            });
          }
      });
    },
    applySearch(value) {
      this.closeSearch();
      this.search = value;
      this.fetchChats();
      this.fetchTotals();
    },
    closeSearch() {
      this.showSearch = false;
    },
    changeTabsTotals(chatCenter) {
      const statusOld = chatCenter.chat_center_status_id_old;
      const status = chatCenter.chat_center_status_id;

      if (statusOld && status !== statusOld) {
        // eslint-disable-next-line
        if ((this.filters.my_chats && chatCenter.user_id === this.user.id) || !this.filters.my_chats) {
          const newIdx = this.statusList
            .findIndex(item => item.value.includes(status));
          const oldIdx = this.statusList
            .findIndex(item => item.value.includes(statusOld));
          if (newIdx !== -1) {
            this.statusList[newIdx].qty += 1;
          }
          if (oldIdx !== -1 && this.statusList[oldIdx].qty > 0) {
            this.statusList[oldIdx].qty -= 1;
          }
        }
      }
      const userOld = chatCenter.user_old;
      const userId = chatCenter.user_id;
      if (userOld && userId !== userOld) {
        if (userId === this.user.id) {
          this.myChats.qty += 1;
        } else if (userId !== this.user.id && this.myChats.qty > 0) {
          this.myChats.qty -= 1;
        }
      }
    },
    openSendModal(id) {
      this.showSendConversation = true;
      this.selectedConversation = id;
    },
    closeSendModal(id) {
      this.showSendConversation = false;
      this.selectedConversation = 0;
    },
    // fetchConfig() {
    //   this.$store.dispatch('GET_CONFIG')
    //     .catch();
    // },
    openAnswerTemplate($event) {
      this.showAnswerTemplate = true;
    },
    closeAnswerTemplates() {
      this.showAnswerTemplate = false;
    },
    selectAnswerTemplate($event) {
      this.templateSelected = $event;
      this.closeAnswerTemplates()
    },
    handleAppend($event) {
      this.templateSelected = {};
      const index = this.sortedChats.findIndex(item => item.id === this.activeChatId);
      if (index >= 0) {
        this.sortedChats.chat_center_messages.push($event);
      }
    },
    fetchChatsData() {
      if (!this.disconected || this.user.role !== 'agent') {
        this.firstScroll = false;
        this.fetchChats();
        this.fetchTotals();
      }
    },
  },
  watch: {
    disconected(value) {
      if (!value) {
        this.fetchChats();
        this.fetchTotals();
        if (this.user.role === 'agent') {
          this.cancelRequest();
          this.chats = [];
        }
      }
      if (value) {
        this.closeChatRoom(this.activeChatId);
        if (this.user.role === 'agent') {
          this.listenEvents = false;
        }
      }
    },
    filters: {
      deep: true,
      handler() {
        if (!this.disconected || this.user.role !== 'agent') {
          this.firstScroll = false;
          this.fetchChats();
          this.fetchTotals();
        }
      },
    },
    activeStatus() {
      this.firstScroll = false;
      this.fetchChats();
    },
    activeChannels(value) {
      this.allChannels.active = value;
    },
    listenEvents(newVal) {
      if (newVal) {
        this.startListeningEvents();
      } else {
        this.stopListeningEvents();
      }
    },
    chats(newVal) {
      this.offset = newVal.length;
    },
  },
};
</script>

<style scoped>
  .position-relative {
    position: relative;
  }
  .position-absolute {
    position: absolute;
  }
  .drawer {
    width: 100% !important;
    z-index: 1;
    position: relative;
  }
  .navbar-header {
    height: 64px;
  }
  .navbar-footer {
    height: 32px;
  }
  .thumbnail {
    border: 2px solid #d3d3d3;
    height: 64px;
    overflow: hidden;
    border-radius: 6px;
  }
  .img-responsive {
    width: 100%;
  }
  .navigation-drawer >>> .toolbar__content {
    height: 96px !important;
  }
  .semi-border--left {
    position: relative;
  }
  .status-tab.semi-border--left:before {
    top: 45%;
    left: -0.5em;
    width: 1px;
    height: 80%;
    border: 1px solid #d3d3d3;
    content: '';
    position: absolute;
    transform: translateY(-50%);
  }
  .semi-border--left:before {
    top: 50%;
    left: 1em;
    width: 1px;
    height: 70%;
    border: 1px solid #d3d3d3;
    content: '';
    position: absolute;
    transform: translateY(-50%);
  }
  .chat-center-container >>> .chat-modal {
    max-height: 95% !important;
    overflow: visible;
  }
  .chat-center-container >>> .chat-config-modal {
    overflow: visible;
  }
  .blured {
    filter: blur(5px);
  }
  .border {
    border: 1px solid #d3d3d3;
    border-radius: 4px;
  }
  .border-bottom {
    border-bottom: 1px solid #d3d3d3;
  }
  .border-left {
    border-left: 1px solid #d3d3d3;
  }
  .border-right {
    border-right: 1px solid #d3d3d3;
  }
  .fade-enter-active, .fade-leave-active {
    transition: all .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .text-truncate {
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>





// WEBPACK FOOTER //
// src/components/chat_center_v2/Index.vue